import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface EmspBoInvoiceListInvoiceNumberHeaderProps
  extends HeaderContext<
    EmspUserInvoiceBaseModel,
    EmspUserInvoiceBaseModel['invoiceNumber']
  > {}

export const EmspBoInvoiceListInvoiceNumberHeader =
  (): // props: EmspBoInvoiceListInvoiceNumberHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-invoice.invoice-number');
  };
